import {
    FETCH_ALL_ARCHIVES_STATUS,
    FETCH_ARCHIVE_MESSAGES_SUCCESS,
    FETCH_ARCHIVES_LOADING,
    FETCH_ARCHIVES_STATUS,
    FETCH_ARCHIVES_STATUS_FAILED,
    FETCHING_ARCHIVE_MESSAGES,
    RESET_ARCHIVE_CHAT,
    SEARCH_ARCHIVES,
    LOAD_MORE_FILTERED_ARCHIVES,
} from "../constants";


import {ENVIRONMENT} from "../environment";
import _ from "lodash";
import algoliasearch from "algoliasearch";
import {auth, database} from "../firebase";

// Archive search results read newest consultation first.
//
// Algolia's browse() walks the index in internal storage order and ignores
// ranking entirely — it exists to export records, not to rank them — so the
// hits for a keyword search come back in no meaningful order, and the order can
// differ between two identical searches. Sort on the consultation timestamp
// before the hits reach the reducer so every search branch agrees.
//
// Sort before enriching, and iterate the sorted array: the enrichment loops
// write back positionally (list[index].ownerProfile = ...), so the array being
// iterated has to be the same one being mutated or profiles land on the wrong
// conversation.
const sortArchivesByConsultation = (hits) =>
    _.orderBy(hits, [(hit) => Number(hit?.timestamp) || 0], ["desc"]);

// Helper function to encode strings for Firebase paths
// Firebase paths cannot contain ".", "#", "$", "[", or "]"
const encodeForFirebasePath = (str) => {
    if (!str) return str;
    return str
        .replace(/\./g, ',')
        .replace(/#/g, '_hash_')
        .replace(/\$/g, '_dollar_')
        .replace(/\[/g, '_lbracket_')
        .replace(/\]/g, '_rbracket_');
};

// Helper function to decode Firebase path strings back to original
const decodeFromFirebasePath = (str) => {
    if (!str) return str;
    return str
        .replace(/,/g, '.')
        .replace(/_hash_/g, '#')
        .replace(/_dollar_/g, '$')
        .replace(/_lbracket_/g, '[')
        .replace(/_rbracket_/g, ']');
};

var client_store = algoliasearch("FL1OI9QKUW", "f0427fde3618b1db1bfb004c623215db");

var index_store = null;

export const setAlgolia = clinicid => {
    return dispatch => {
        // convertArchivesData();
        if (clinicid) {
            index_store = client_store.initIndex(clinicid + "_conversations");
        } else {
            if (ENVIRONMENT === "development") {
                index_store = client_store.initIndex("stg_conversations");
            } else {
                index_store = client_store.initIndex("conversations");
            }
        }
    };
};
export const fetchArchives = (archives, timestamp) => {
    return dispatch => {
        // convertArchivesData();
        fetchArchivesData(dispatch, archives, timestamp);
    };
};

const convertArchivesData = () => {
    getOpenArchivesRef().once("value", archiveSnap => {
        if (archiveSnap.val()) {
            archiveSnap.forEach(valSnap => {
                if (!valSnap.val().status) {
                    var updates = {};
                    updates[`/archiveConversations/${valSnap.key}`] = valSnap.val();
                    updates[`/openconversations/${valSnap.key}`] = null;
                    database
                        .ref()
                        .update(updates)
                        .then(data => {
                        })
                        .catch(error => {
                        });
                }
            });
        }
    });
};

const fetchArchivesData = (dispatch, oldArchives, timestamp) => {
    dispatch({type: FETCH_ARCHIVES_LOADING});
    var archives = [];

    let archive_list = getArchivesRef().orderByChild("timestamp").limitToLast(100);
    if (Boolean(timestamp)) archive_list = archive_list.endAt(timestamp);
    archive_list.once("value", archiveSnap => {
        if (archiveSnap.val()) {
            var count = archiveSnap.numChildren();
            var i = 0;
            var archive_index = 0;
            archiveSnap.forEach(valSnap => {
                archive_index = archive_index + 1;
                if (!valSnap.val().status) {
                    getdoctorByRef(valSnap.val().doctorID).once("value", doctorSnap => {
                        if (doctorSnap.val()) {
                            getUserRef(valSnap.val().patientID).once("value", patientSnap => {
                                if (patientSnap.val()) {

                                    let owner = valSnap.val()?.owner === valSnap.val().patientID? null:  valSnap.val()?.owner  || null;
                                    let ownerProfile = owner? patientSnap.val().profiles? patientSnap.val().profiles[owner] : null : null;
                                    if (ownerProfile){
                                        ownerProfile.uid = owner;
                                    }
                                    let userName =
                                        (patientSnap.val().userName === "No name" ||
                                            patientSnap.val().userName === "Patient") &&
                                        patientSnap.val().name
                                            ? patientSnap.val().name
                                            : patientSnap.val().userName;
                                    let archiveData = valSnap.val();
                                    let chatCount = patientSnap.val().history_conversations;

                                    archiveData.conversationID = valSnap.key;
                                    archiveData.patientEmail = patientSnap.val().email;
                                    archiveData.city = patientSnap.val().city;
                                    archiveData.country = patientSnap.val().country;
                                    archiveData.platform = patientSnap.val().platform;
                                    archiveData.DOB = patientSnap.val().DOB;
                                    archiveData.ownerProfile = ownerProfile;
                                    archiveData.gender = patientSnap.val().gender;
                                    archiveData.symptoms = archiveData?.symptoms || archiveData?.followUpData?.diagnosis
                                    archiveData.currentMedication = archiveData?.medications || patientSnap.val().medication;
                                    archiveData.gmtOffset = patientSnap.val().gmtOffset;
                                    archiveData.buildNumber = patientSnap.val().buildNumber;
                                    archiveData.patientName = userName;
                                    archiveData.convoCount =
                                        chatCount !== null && chatCount !== undefined
                                            ? Object.keys(chatCount).length
                                            : 0;
                                    archiveData.doctorName = doctorSnap.val().doctorName;
                                    archiveData.doctorID = valSnap.val().doctorID;
                                    archiveData.adminDoctor = valSnap.val().adminDoctor||"";
                                    archiveData.doctorProfileImg = doctorSnap.val().profileImageURL;
                                    archiveData.doctorEmail = doctorSnap.val().email;
                                    archiveData.healthInsuranceCardBack = patientSnap.val().healthInsuranceCardBack;
                                    archiveData.healthInsuranceCardFront = patientSnap.val().healthInsuranceCardFront;
                                    archiveData.healthInsuranceCardNumber = patientSnap.val().healthInsuranceCardNumber;
                                    archives.push(archiveData);

                                    if (count - 1 === i) {
                                        returnArchives(dispatch, oldArchives, archives, count, i);
                                    } else {
                                        i = i + 1;
                                    }
                                } else {
                                    i = i + 1;
                                    if (count === i && archives.length === 0) {
                                        dispatch({
                                            type: FETCH_ARCHIVES_STATUS,
                                            payload: [],
                                        });
                                    } else if (count === i && archives.length !== 0) {
                                        returnArchives(dispatch, oldArchives, archives, count, i);
                                    }
                                }
                            });
                        } else {
                            i = i + 1;
                            if (count === i && archives.length === 0) {
                                dispatch({
                                    type: FETCH_ARCHIVES_STATUS,
                                    payload: [],
                                });
                            } else if (count === i && archives.length !== 0) {
                                returnArchives(dispatch, oldArchives, archives, count, i);
                            }
                        }
                    });
                } else {
                    i = i + 1;
                    if (count === i && archives.length === 0) {
                        dispatch({
                            type: FETCH_ARCHIVES_STATUS,
                            payload: [],
                        });
                    } else if (count === i && archives.length !== 0) {
                        returnArchives(dispatch, oldArchives, archives, count, i);
                    }
                }
            });
        } else {
            dispatch({
                type: FETCH_ARCHIVES_STATUS,
                payload: [],
            });
        }
    });
};

const storeIndex = (archiveData, i) => {
    if (i === archiveData.length) {
        return;
    }

    return index_store
        .addObject(archiveData[i])
        .then(data => {
            storeIndex(archiveData, i + 1);
        })
        .catch(error => {
            storeIndex(archiveData, i + 1);
        });
};

export const fetchAllArchivesData = () => {
    return dispatch => {
        database
            .ref()
            .child("archiveConversations")
            .orderByChild("timestamp")
            .limitToLast(10)
            .once("value", archiveSnap => {
                if (archiveSnap.val()) {
                    var count = archiveSnap.numChildren();
                    var i = 0;
                    var archives = [];
                    archiveSnap.forEach(valSnap => {
                        if (!valSnap.val().status) {
                            var convos = "";

                            database
                                .ref(`/conversations/${valSnap.key}`)
                                .once("value", convoSnap => {
                                    convoSnap.forEach(convoInstance => {
                                        if (convoInstance.val().type === "text") {
                                            convos = convos + convoInstance.val().content;
                                        }
                                    });
                                })
                                .then(data => {
                                    database
                                        .ref(`/doctors/${valSnap.val().doctorID}`)
                                        .once("value", doctorSnap => {
                                            if (doctorSnap.val()) {
                                                database
                                                    .ref(`/users/${valSnap.val().patientID}`)
                                                    .once("value", patientSnap => {
                                                        if (patientSnap.val()) {
                                                            let userName =
                                                                (patientSnap.val().userName === "No name" ||
                                                                    patientSnap.val().userName === "Patient") &&
                                                                patientSnap.val().name
                                                                    ? patientSnap.val().name
                                                                    : patientSnap.val().userName;
                                                            let archiveData = valSnap.val();
                                                            let tags = "";
                                                            if (Boolean(archiveData.tagsList)) {
                                                                var tagslist = _.map(archiveData.tagsList, (val, uid) => {
                                                                    return {...val, uid};
                                                                });
                                                                tagslist.forEach(tag => {
                                                                    if (Boolean(tag.name)) {
                                                                        tags = tags + ", " + tag.name;
                                                                    }
                                                                });
                                                            }

                                                            archiveData.tags = tags;
                                                            archiveData.objectID = valSnap.key;
                                                            archiveData.conversations = convos;
                                                            archiveData.category = valSnap.val().category;
                                                            archiveData.doctorID = valSnap.val().doctorID;
                                                            archiveData.patientID = valSnap.val().patientID;
                                                            let chatCount = patientSnap.val().history_conversations;
                                                            archiveData.conversationID = valSnap.key;
                                                            archiveData.patientEmail = patientSnap.val().email;
                                                            archiveData.city = patientSnap.val().city;
                                                            archiveData.country = patientSnap.val().country;
                                                            archiveData.platform = patientSnap.val().platform;
                                                            archiveData.DOB = patientSnap.val().DOB;
                                                            archiveData.gender = patientSnap.val().gender;
                                                            archiveData.symptoms = patientSnap?.val()?.symptoms || archiveData?.followUpData?.diagnosis
                                                            archiveData.medication = patientSnap.val().medication;
                                                            archiveData.gmtOffset = patientSnap.val().gmtOffset;
                                                            archiveData.buildNumber = patientSnap.val().buildNumber;
                                                            archiveData.patientName = userName;
                                                            archiveData.convoCount =
                                                                chatCount !== null && chatCount !== undefined
                                                                    ? Object.keys(chatCount).length
                                                                    : 0;
                                                            archiveData.doctorName = doctorSnap.val().doctorName;
                                                            archiveData.doctorID = valSnap.val().doctorID;
                                                            archiveData.doctorProfileImg = doctorSnap.val().profileImageURL;
                                                            archiveData.doctorEmail = doctorSnap.val().email;
                                                            archiveData.user_id = patientSnap.val().user_id;
                                                            archives.push(archiveData);

                                                            if (i === count - 1) {
                                                                storeIndex(archives, 0);
                                                                dispatch({
                                                                    type: FETCH_ALL_ARCHIVES_STATUS,
                                                                    payload: [],
                                                                });
                                                            } else {
                                                                i = i + 1;
                                                            }
                                                        } else {
                                                            i = i + 1;
                                                        }
                                                    })
                                                    .then(data => {
                                                    })
                                                    .catch(error => {
                                                    });
                                            } else {
                                                i = i + 1;
                                            }
                                        })
                                        .then(data => {
                                        })
                                        .catch(error => {
                                        });
                                })
                                .catch(error => {
                                });
                        } else {
                            i = i + 1;
                        }
                    });
                } else {

                }
            })
            .then(data => {
                dispatch({
                    type: FETCH_ALL_ARCHIVES_STATUS,
                    payload: [],
                });
            })
            .catch(error => {
            });
    };
};

export const fetchArchiveMessages = (
    user_id,
    patientEmail,
    patientName,
    doctorName,
    doctorID,
    patientID,
    doctorImage,
    conversationID,
    tagsList,
    city,
    country,
    platform,
    DOB,
    gender,
    issue,
    currentMedication,
    diagnosisValue,
    opinionDescriptionValue,
    commentAdded,
    medications,
    followUpData,
    gmtOffset,
    buildNumber,
    convoCount,
    averageSleep,
    currentSleep,
    heartRate,
    heightCm,
    heightFeet,
    stepCount,
    runningWalking,
    weightKg,
    weightLbs,
    periodStartDate,
    flowType,
    restingHeartRate,
    complete_address,
    timestamp,
    issueResolved,
    symptoms,
    findings,
    assessment,
    plan,
    ownerProfile,
    owner,
    icd,
    billing_code,
    billing_unit,
    prescriptions,
    requisitions,
    special_referals,
    video_consult,
    followUpDays
) => {
    return dispatch => {
        dispatch({type: FETCHING_ARCHIVE_MESSAGES});

        getConversationRef(conversationID).once("value", snap => {
            if (snap.val()) {
                var count = snap.numChildren();
                var i = 0;
                var messages = [];
                snap.forEach(function (childSnapshot) {
                    let receiveMessage = childSnapshot.val();
                    receiveMessage.uid = childSnapshot.key;

                    if (receiveMessage.toID === patientID) {
                        receiveMessage.direction = "right";
                    } else {
                        receiveMessage.direction = "left";
                    }

                    let objMessages = {receiveMessage: receiveMessage};

                    messages.push(objMessages);
                    if (count - 1 === i) {
                        i = count - 1;
                        database.ref(`users/${patientID}`).once('value', s => {
                            if (s.exists()) {
                                //let owner = s.val()?.owner === patientID? null:  s.val()?.owner  || null;
                                //console.log("FETCH_ARCHIVE_MESSAGES_SUCCESS owner ", owner)

                                let ownerProfile = owner? s.val().profiles[owner] : null;
                                if (ownerProfile){
                                    ownerProfile.uid = owner;
                                }
                                console.log("FETCH_ARCHIVE_MESSAGES_SUCCESS ownerProfile ", ownerProfile)
                                dispatch({
                                    type: FETCH_ARCHIVE_MESSAGES_SUCCESS,
                                    payload: {
                                        patientID,
                                        user_id: user_id,
                                        issue:issue,
                                        messages: messages,
                                        location: conversationID,
                                        doctorId: doctorID,
                                        doctorName: doctorName,
                                        doctorImage: doctorImage,
                                        patientEmail: patientEmail,
                                        patientName: patientName,
                                        city: city,
                                        country: country,
                                        complete_address: complete_address,
                                        phone_number: s.val().phone_number,
                                        platform: platform,
                                        DOB: DOB,
                                        ownerProfile:ownerProfile,
                                        gender: gender,
                                        timestamp: timestamp,
                                        currentMedication: currentMedication,
                                        diagnosisValue: diagnosisValue,
                                        opinionDescriptionValue: opinionDescriptionValue,
                                        medicationData: medications,
                                        followUpData: followUpData,
                                        commentAdded: commentAdded,
                                        gmtOffset: gmtOffset,
                                        buildNumber: buildNumber,
                                        convoCount: convoCount,
                                        averageSleep: averageSleep,
                                        currentSleep: currentSleep,
                                        heartRate: heartRate,
                                        heightCm: heightCm,
                                        heightFeet: heightFeet,
                                        stepCount: stepCount,
                                        runningWalking: runningWalking,
                                        weightKg: weightKg,
                                        weightLbs: weightLbs,
                                        periodStartDate: periodStartDate,
                                        flowType: flowType,
                                        restingHeartRate: restingHeartRate,
                                        symptoms: symptoms,
                                        findings: findings,
                                        assessment: assessment,
                                        plan: plan,
                                        icd: icd,
                                        billing_code: billing_code,
                                        billing_unit: billing_unit,
                                        issueResolved: issueResolved,
                                        prescriptions: prescriptions,
                                        requisitions: requisitions,
                                        healthCardNumber: s.val().healthInsuranceCardNumber,
                                        healthInsuranceCardBack: s.val().healthInsuranceCardBack || null,
                                        healthInsuranceCardFront: s.val().healthInsuranceCardFront || null,
                                        healthInsuranceCardNumber: s.val().healthInsuranceCardNumber || null,
                                        special_referals: special_referals,
                                        video_consult: video_consult,
                                        followUpDays: followUpDays,
                                    },
                                });
                            }
                        })

                    } else {
                        i = i + 1;
                    }
                });
            } else {
                dispatch({
                    type: FETCH_ARCHIVE_MESSAGES_SUCCESS,
                    payload: [],
                });
            }
        });
    };
};

export const fetchClinicalArchiveMessages = (
    user_id,
    patientEmail,
    patientName,
    doctorName,
    doctorID,
    patientID,
    doctorImage,
    conversationID,
    tagsList,
    city,
    country,
    platform,
    DOB,
    gender,
    issue,
    currentMedication,
    diagnosisValue,
    opinionDescriptionValue,
    commentAdded,
    medications,
    followUpData,
    gmtOffset,
    buildNumber,
    convoCount,
    averageSleep,
    currentSleep,
    heartRate,
    heightCm,
    heightFeet,
    stepCount,
    runningWalking,
    weightKg,
    weightLbs,
    periodStartDate,
    flowType,
    restingHeartRate,
    complete_address,
    timestamp,
    issueResolved,
    symptoms,
    findings,
    assessment,
    plan,
    icd,
    billing_code,
    billing_unit,
    prescriptions,
    requisitions,
    special_referals,
    video_consult,
    followUpDays,
    archiveObj
) => {
    return dispatch => {
        dispatch({type: FETCHING_ARCHIVE_MESSAGES});

        getConversationRef(conversationID).once("value", snap => {
            if (snap.val()) {
                var count = snap.numChildren();
                var i = 0;
                var messages = [];
                snap.forEach(function (childSnapshot) {
                    let receiveMessage = childSnapshot.val();
                    receiveMessage.uid = childSnapshot.key;

                    if (receiveMessage.toID === patientID) {
                        receiveMessage.direction = "right";
                    } else {
                        receiveMessage.direction = "left";
                    }

                    let objMessages = {receiveMessage: receiveMessage};

                    messages.push(objMessages);
                    if (count - 1 === i) {
                        i = count - 1;
                        database.ref(`users/${patientID}`).once('value', s => {
                                if (s.exists()) {
                                    dispatch({
                                        type: FETCH_ARCHIVE_MESSAGES_SUCCESS,
                                        payload: {
                                            patientID,
                                            user_id: user_id,
                                            messages: messages,
                                            location: conversationID,
                                            doctorId: doctorID,
                                            doctorName: doctorName,
                                            doctorImage: doctorImage,
                                            patientEmail: patientEmail,
                                            patientName: patientName,
                                            city: city,
                                            country: country,
                                            complete_address: complete_address,
                                            phone_number: s.val().phone_number,
                                            platform: platform,
                                            DOB: DOB,
                                            gender: gender,
                                            timestamp: timestamp,
                                            currentMedication: currentMedication,
                                            diagnosisValue: diagnosisValue,
                                            opinionDescriptionValue: opinionDescriptionValue,
                                            medicationData: medications,
                                            followUpData: followUpData,
                                            commentAdded: commentAdded,
                                            gmtOffset: gmtOffset,
                                            buildNumber: buildNumber,
                                            convoCount: convoCount,
                                            averageSleep: averageSleep,
                                            currentSleep: currentSleep,
                                            heartRate: heartRate,
                                            heightCm: heightCm,
                                            heightFeet: heightFeet,
                                            stepCount: stepCount,
                                            runningWalking: runningWalking,
                                            weightKg: weightKg,
                                            weightLbs: weightLbs,
                                            periodStartDate: periodStartDate,
                                            flowType: flowType,
                                            restingHeartRate: restingHeartRate,
                                            symptoms: symptoms,
                                            findings: findings,
                                            assessment: assessment,
                                            plan: plan,
                                            icd: icd,
                                            billing_code: billing_code,
                                            billing_unit: billing_unit,
                                            issueResolved: issueResolved,
                                            prescriptions: prescriptions,
                                            requisitions: requisitions,
                                            special_referals: special_referals,
                                            healthCardNumber: s.val().healthInsuranceCardNumber,
                                            healthInsuranceCardBack: s.val().healthInsuranceCardBack,
                                            healthInsuranceCardFront: s.val().healthInsuranceCardFront,
                                            healthInsuranceCardNumber: s.val().healthInsuranceCardNumber,
                                            video_consult: video_consult,
                                            followUpDays: followUpDays,
                                            selectedArchiveObj: archiveObj,
                                        },
                                    });
                                }
                            }
                        )
                    } else {
                        i = i + 1;
                    }
                });
            } else {
                dispatch({
                    type: FETCH_ARCHIVE_MESSAGES_SUCCESS,
                    payload: [],
                });
            }
        });
    };
};

export const resetArchiveMessages = () => {
    return dispatch => {
        dispatch({
            type: RESET_ARCHIVE_CHAT
        });
    };
};

export const searchArchives = (input, archives, type) => {
    return dispatch => {
        console.log("========================================");
        console.log("searchArchives CALLED");
        console.log("Parameters:", { 
            input, 
            inputLength: input?.length, 
            type, 
            typeOf: typeof type,
            archivesCount: archives?.length 
        });
        console.log("========================================");
        
        dispatch({type: FETCH_ARCHIVES_LOADING});
        dispatch({
            type: RESET_ARCHIVE_CHAT
        });
        let newArchives = archives;
        
        // Chat ID search - handle FIRST (highest priority)
        if(type === "chat-id" && input && input.length > 0){
            console.log("========== CHAT ID SEARCH MODE ==========");
            console.log("Searching for chat ID:", input);
            
            // Validate input - Firebase paths cannot contain . # $ [ ] @
            const invalidChars = /[.#$\[\]@]/;
            if (invalidChars.test(input)) {
                dispatch({
                    type: SEARCH_ARCHIVES,
                    payload: {
                        archives: [],
                        fullFilteredList: [],
                        currentPage: 1,
                        hasMore: false
                    },
                });
                return;
            }
            
            // Treat as conversation ID - try direct lookup first (without encoding)
            console.log("Treating input as conversation ID, attempting direct lookup");
            database.ref(`archiveConversations/${input}`).once('value', valSnap => {
                if (valSnap.val()) {
                    getdoctorByRef(valSnap.val().doctorID).once("value", doctorSnap => {
                        if (doctorSnap.val()) {
                            getUserRef(valSnap.val().patientID).once("value", patientSnap => {
                                let owner = valSnap.val()?.owner === valSnap.val().patientID? null:  valSnap.val()?.owner  || null;
                                let ownerProfile = owner? patientSnap.val().profiles? patientSnap.val().profiles[owner] : null : null;
                                if (ownerProfile){
                                    ownerProfile.uid = owner;
                                }
                                if (patientSnap.val()) {
                                    let userName =
                                        (patientSnap.val().userName === "No name" ||
                                            patientSnap.val().userName === "Patient") &&
                                        patientSnap.val().name
                                            ? patientSnap.val().name
                                            : patientSnap.val().userName;
                                    let archiveData = valSnap.val();
                                    let chatCount = patientSnap.val().history_conversations;

                                    archiveData.conversationID = valSnap.key;
                                    archiveData.patientEmail = patientSnap.val().email;
                                    archiveData.city = patientSnap.val().city;
                                    archiveData.country = patientSnap.val().country;
                                    archiveData.platform = patientSnap.val().platform;
                                    archiveData.DOB = patientSnap.val().DOB;
                                    archiveData.gender = patientSnap.val().gender;
                                    archiveData.symptoms = patientSnap?.val()?.symptoms || archiveData?.followUpData?.diagnosis
                                    archiveData.currentMedication = patientSnap.val().medication;
                                    archiveData.gmtOffset = patientSnap.val().gmtOffset;
                                    archiveData.buildNumber = patientSnap.val().buildNumber;
                                    archiveData.patientName = userName;
                                    archiveData.ownerProfile = ownerProfile;
                                    archiveData.convoCount =
                                        chatCount !== null && chatCount !== undefined
                                            ? Object.keys(chatCount).length
                                            : 0;
                                    archiveData.doctorName = doctorSnap.val().doctorName;
                                    archiveData.doctorID = valSnap.val().doctorID;
                                    archiveData.adminDoctor = valSnap.val().adminDoctor||"";
                                    archiveData.doctorProfileImg = doctorSnap.val().profileImageURL;
                                    archiveData.doctorEmail = doctorSnap.val().email;
                                    let archives = [];
                                    archives.push(archiveData);
                                    dispatch({
                                        type: SEARCH_ARCHIVES,
                                        payload: {
                                            archives: archives,
                                            fullFilteredList: [],
                                            currentPage: 1,
                                            hasMore: false
                                        },
                                    });
                                } else {
                                    dispatch({
                                        type: SEARCH_ARCHIVES,
                                        payload: {
                                            archives: [],
                                            fullFilteredList: [],
                                            currentPage: 1,
                                            hasMore: false
                                        },
                                    });
                                }
                            });
                        } else {
                            dispatch({
                                type: SEARCH_ARCHIVES,
                                payload: {
                                    archives: [],
                                    fullFilteredList: [],
                                    currentPage: 1,
                                    hasMore: false
                                },
                            });
                        }
                    });
                }else{
                    dispatch({
                        type: SEARCH_ARCHIVES,
                        payload: {
                            archives: [],
                            fullFilteredList: [],
                            currentPage: 1,
                            hasMore: false
                        },
                    });
                }
            });
            return; // Add return to prevent falling through to text search
        }
        
        // Email search - handle if input contains @ and no special type
        if ((!type || type === "") && input && input.length > 0 && input.includes('@')) {
            console.log("========== EMAIL SEARCH MODE ==========");
            console.log("Searching for email:", input);
            
            // Use browse to search across all fields including patientEmail
            index_store.browse({query: input}, function searchDone(err, content) {
                console.log("Algolia browse response:", { err, hasContent: Boolean(content), hits: content?.hits?.length });
                
                if (!Boolean(err) && Boolean(content) && content.hits && content.hits.length > 0) {
                    newArchives = sortArchivesByConsultation(content.hits);
                    let count = 0;
                    let length = newArchives.length;
                    console.log(`Found ${length} conversations for email: ${input}`);

                    if(length > 0) {
                        newArchives.forEach((hit, index) => {
                            console.log("hit ", hit);
                            let owner = hit?.owner === hit.patientID ? null : hit.owner || null;
                            if (owner) {
                                console.log("searchDone owner ", owner);
                                database.ref(`/users/${hit.patientID}/profiles/${owner}`).once("value", patientProfileSnap => {
                                    let ownerProfile = patientProfileSnap.exists() ? patientProfileSnap.toJSON() : null;
                                    console.log("searchDone ownerProfile ", ownerProfile);
                                    if (ownerProfile) {
                                        ownerProfile.uid = owner;
                                    }
                                    newArchives[index].ownerProfile = ownerProfile;
                                    count++;
                                    if (count >= length) {
                                        dispatch({
                                            type: SEARCH_ARCHIVES,
                                            payload: {
                                                archives: newArchives,
                                                fullFilteredList: [],
                                                currentPage: 1,
                                                hasMore: false
                                            },
                                        });
                                    }
                                });
                            } else {
                                count++;
                                if (count >= length) {
                                    dispatch({
                                        type: SEARCH_ARCHIVES,
                                        payload: {
                                            archives: newArchives,
                                            fullFilteredList: [],
                                            currentPage: 1,
                                            hasMore: false
                                        },
                                    });
                                }
                            }
                        });
                    } else {
                        dispatch({
                            type: SEARCH_ARCHIVES,
                            payload: {
                                archives: [],
                                fullFilteredList: [],
                                currentPage: 1,
                                hasMore: false
                            },
                        });
                    }
                } else {
                    console.log("No conversations found for email:", input);
                    dispatch({
                        type: SEARCH_ARCHIVES,
                        payload: {
                            archives: [],
                            fullFilteredList: [],
                            currentPage: 1,
                            hasMore: false
                        },
                    });
                }
            });
            return;
        }
        
        // Regular text search (if input > 2 chars and no special type or empty string type)
        if ((!type || type === "") && input && input.length > 2) {
            console.log("========== TEXT SEARCH MODE ==========");
            console.log("Searching for text:", input);
            index_store.browse({query: input}, function searchDone(err, content) {
                if (!Boolean(err) && Boolean(content)) {
                    newArchives = sortArchivesByConsultation(content.hits);
                    let count = 0;
                    let length = newArchives.length;
                    if(length>0){
                        newArchives.forEach((hit, index)=>{
                            console.log("hit ", hit)
                            let owner = hit?.owner === hit.patientID? null:  hit.owner  || null;
                            if(owner){
                                console.log("searchDone owner ", owner)
                                database.ref(`/users/${hit.patientID}/profiles/${owner}`).once("value", patientProfileSnap => {
                                    let ownerProfile = patientProfileSnap.exists()? patientProfileSnap.toJSON():null;
                                    console.log("searchDone ownerProfile ", ownerProfile)
                                    if (ownerProfile){
                                        ownerProfile.uid = owner;
                                    }
                                    newArchives[index].ownerProfile = ownerProfile;
                                    count++;
                                    if(count >= length){
                                        dispatch({
                                            type: SEARCH_ARCHIVES,
                                            payload: {
                                                archives: newArchives,
                                                fullFilteredList: [],
                                                currentPage: 1,
                                                hasMore: false
                                            },
                                        });
                                    }

                                })
                            }else{
                                count++;
                                if(count >= length){
                                    dispatch({
                                        type: SEARCH_ARCHIVES,
                                        payload: {
                                            archives: newArchives,
                                            fullFilteredList: [],
                                            currentPage: 1,
                                            hasMore: false
                                        },
                                    });
                                }
                            }
                        })
                    }else {
                        dispatch({
                            type: SEARCH_ARCHIVES,
                            payload: {
                                archives: [],
                                fullFilteredList: [],
                                currentPage: 1,
                                hasMore: false
                            },
                        });
                    }
                } else {
                    dispatch({
                        type: SEARCH_ARCHIVES,
                        payload: {
                            archives: [],
                            fullFilteredList: [],
                            currentPage: 1,
                            hasMore: false
                        },
                    });
                }
            });
            return;
        }
        
        // Empty input - fetch default archives
        if ((!type || type === "") && (!input || input.length === 0)) {
            console.log("========== DEFAULT FETCH MODE ==========");
            console.log("Loading default archives (input is empty)");
            fetchArchivesData(dispatch, [], new Date().getTime());
            return;
        }
        
        // Handle filters (date range, doctor filter, etc.)
        // Only process as filter if type is a string containing filter syntax
        if (type && typeof type === 'string' && (type.includes(':') || type.includes('AND'))) {
            console.log("========== FILTER SEARCH MODE (ALGOLIA SERVER-SIDE) ==========");
            console.log("Searching with filters:", type);

            // Parse filter string into facetFilters, numericFilters, and filters
            // for reliable filtering with Algolia v3 client
            const filterParts = type.split(' AND ').map(f => f.trim());
            const facetFilters = [];
            const numericFilters = [];
            const booleanFilters = []; // for boolean fields — use filters param

            filterParts.forEach(filter => {
                if (filter.match(/^timestamp/)) {
                    // Numeric filters (timestamp>=123, timestamp<=456)
                    numericFilters.push(filter);
                } else if (filter.startsWith('NOT ') || filter.includes('isPhysioPatient')) {
                    // Boolean filters go through 'filters' param (handles true/false properly)
                    booleanFilters.push(filter);
                } else {
                    // String facet filter: adminDoctor:"Marsha Dunkley" → adminDoctor:Marsha Dunkley
                    facetFilters.push(filter.replace(/"/g, ''));
                }
            });

            const searchOptions = {
                query: "",
                hitsPerPage: 1000
            };

            if (facetFilters.length > 0) {
                searchOptions.facetFilters = facetFilters;
            }
            if (numericFilters.length > 0) {
                searchOptions.numericFilters = numericFilters;
            }
            if (booleanFilters.length > 0) {
                searchOptions.filters = booleanFilters.join(' AND ');
            }

            console.log("Search options sent to Algolia:", searchOptions);
            console.log("Facet filters:", facetFilters);
            console.log("Numeric filters:", numericFilters);
            console.log("Boolean filters:", booleanFilters);
            
            index_store.search(searchOptions, function searchDone(err, content) {
                console.log("========== ALGOLIA RESPONSE ==========");
                console.log("Search response:", { err, hits: content?.hits?.length, nbHits: content?.nbHits });
                if (err) {
                    console.error("Algolia search error:", err);
                    dispatch({
                        type: SEARCH_ARCHIVES,
                        payload: {
                            archives: [],
                            fullFilteredList: [],
                            currentPage: 1,
                            hasMore: false
                        },
                    });
                    return;
                }
                
                if (Boolean(content) && content.hits) {
                    newArchives = sortArchivesByConsultation(content.hits);

                    console.log(`✅ Algolia returned: ${newArchives.length} records (filtered server-side)`);
                    console.log(`✅ Total matching in Algolia: ${content.nbHits}`);
                    console.log("Sorted results by timestamp (latest first)");
                    
                    // For pagination
                    const pageSize = 100;
                    
                    // Show first 100 for display
                    const displayArchives = newArchives.slice(0, Math.min(pageSize, newArchives.length));
                    
                    let count = 0;
                    let length = displayArchives.length;
                    console.log(`========== FINAL RESULTS ==========`);
                    console.log(`Total matching in Algolia: ${content.nbHits} records`);
                    console.log(`Fetched this page: ${newArchives.length} records`);
                    console.log(`Showing initially: ${length} records`);
                    console.log(`Has more pages in Algolia: ${content.nbHits > newArchives.length}`);
                    console.log(`===================================`);
                    
                    if(length>0){
                        displayArchives.forEach((hit, index)=>{
                            let owner = hit?.owner === hit.patientID? null:  hit.owner  || null;
                            if(owner){
                                database.ref(`/users/${hit.patientID}/profiles/${owner}`).once("value", patientProfileSnap => {
                                    let ownerProfile = patientProfileSnap.exists()? patientProfileSnap.toJSON():null;
                                    if (ownerProfile){
                                        ownerProfile.uid = owner;
                                    }
                                    displayArchives[index].ownerProfile = ownerProfile;
                                    count++;
                                    if(count >= length){
                                        console.log(`[DISPATCH] Sending ${displayArchives.length} archives to reducer`);
                                        dispatch({
                                            type: SEARCH_ARCHIVES,
                                            payload: {
                                                archives: displayArchives,
                                                fullFilteredList: newArchives,
                                                currentPage: 1,
                                                hasMore: newArchives.length > pageSize,
                                                algoliaHasMore: content.nbHits > newArchives.length,
                                                algoliaPage: 0,
                                                algoliaFilters: type
                                            },
                                        });
                                    }

                                })
                            }else{
                                count++;
                                if(count >= length){
                                    console.log(`[DISPATCH] Sending ${displayArchives.length} archives to reducer`);
                                    dispatch({
                                        type: SEARCH_ARCHIVES,
                                        payload: {
                                            archives: displayArchives,
                                            fullFilteredList: newArchives,
                                            currentPage: 1,
                                            hasMore: newArchives.length > pageSize,
                                            algoliaHasMore: content.nbHits > newArchives.length,
                                            algoliaPage: 0,
                                            algoliaFilters: type
                                        },
                                    });
                                }
                            }
                        })
                    }else {
                        console.log("[DISPATCH] No results found with filters, sending empty array");
                        dispatch({
                            type: SEARCH_ARCHIVES,
                            payload: {
                                archives: [],
                                fullFilteredList: [],
                                currentPage: 1,
                                hasMore: false,
                                algoliaHasMore: false,
                                algoliaPage: 0,
                                algoliaFilters: ""
                            },
                        });
                    }
                } else {
                    console.log("No content returned from search");
                    dispatch({
                        type: SEARCH_ARCHIVES,
                        payload: {
                            archives: [],
                            fullFilteredList: [],
                            currentPage: 1,
                            hasMore: false,
                            algoliaHasMore: false,
                            algoliaPage: 0,
                            algoliaFilters: ""
                        },
                    });
                }
            });
            return;
        }
        
        // If we reach here, invalid parameters
        console.log("========== NO VALID ACTION ==========");
        console.log("No valid search parameters provided");
    };
};

export const loadMoreFilteredArchives = () => {
    return (dispatch, getState) => {
        const state = getState().archivesReducer;
        const { fullFilteredList, archives, currentPage } = state;
        
        if (!fullFilteredList || fullFilteredList.length === 0) {
            console.log("No more filtered results to load");
            return;
        }
        
        const pageSize = 100;
        const nextPage = currentPage + 1;
        const startIndex = currentPage * pageSize;
        const endIndex = startIndex + pageSize;
        
        const nextBatch = fullFilteredList.slice(startIndex, endIndex);
        const hasMore = endIndex < fullFilteredList.length;
        
        console.log(`Loading page ${nextPage}: ${nextBatch.length} more results`);
        console.log(`Total loaded: ${archives.length + nextBatch.length} of ${fullFilteredList.length}`);
        
        // Process owner profiles for new batch
        let count = 0;
        let processedBatch = [...nextBatch];
        
        if (processedBatch.length > 0) {
            processedBatch.forEach((hit, index) => {
                let owner = hit?.owner === hit.patientID ? null : hit.owner || null;
                if (owner) {
                    database.ref(`/users/${hit.patientID}/profiles/${owner}`).once("value", patientProfileSnap => {
                        let ownerProfile = patientProfileSnap.exists() ? patientProfileSnap.toJSON() : null;
                        if (ownerProfile) {
                            ownerProfile.uid = owner;
                        }
                        processedBatch[index].ownerProfile = ownerProfile;
                        count++;
                        if (count >= processedBatch.length) {
                            dispatch({
                                type: LOAD_MORE_FILTERED_ARCHIVES,
                                payload: {
                                    newArchives: processedBatch,
                                    currentPage: nextPage,
                                    hasMore: hasMore
                                }
                            });
                        }
                    });
                } else {
                    count++;
                    if (count >= processedBatch.length) {
                        dispatch({
                            type: LOAD_MORE_FILTERED_ARCHIVES,
                            payload: {
                                newArchives: processedBatch,
                                currentPage: nextPage,
                                hasMore: hasMore
                            }
                        });
                    }
                }
            });
        }
    };
};

export const fetchPatientsClinicalArchives = (patientid, clinicid) => {
    var timestamp = null;
    return dispatch => {
        dispatch({type: FETCH_ARCHIVES_LOADING});

        const {currentUser} = auth;
        let currentUserID = currentUser.uid;

        getClinicStaffMemberRef(clinicid, currentUserID).once("value", doctorSnapshot => {
            if (doctorSnapshot.val()) {
                getUserHistoryConversationRef(patientid).once("value", historySnap => {
                    historySnap.forEach(childHistorySnapshot => {
                        if (childHistorySnapshot.val()) {
                            var count = historySnap.numChildren();
                            var i = 0;
                            var archives = [];
                            historySnap.forEach(childHistorySnapshot => {
                                var convoId = childHistorySnapshot.val().location;
                                getClinicalArchiveRef(clinicid, convoId).once("value", valSnap => {
                                    if (valSnap.val()) {
                                        if (!valSnap.val().status) {
                                            getClinicStaffMemberRef(clinicid, valSnap.val().doctorID).once(
                                                "value",
                                                doctorSnap => {
                                                    if (doctorSnap.val()) {
                                                        getUserRef(valSnap.val().patientID).once("value", patientSnap => {
                                                            if (patientSnap.val()) {
                                                                let userName =
                                                                    (patientSnap.val().userName === "No name" ||
                                                                        patientSnap.val().userName === "Patient") &&
                                                                    patientSnap.val().name
                                                                        ? patientSnap.val().name
                                                                        : patientSnap.val().userName;
                                                                let archiveData = valSnap.val();
                                                                let chatCount = patientSnap.val().history_conversations;

                                                                archiveData.conversationID = valSnap.key;
                                                                archiveData.patientEmail = patientSnap.val().email;
                                                                archiveData.city = patientSnap.val().city;
                                                                archiveData.country = patientSnap.val().country;
                                                                archiveData.platform = patientSnap.val().platform;
                                                                archiveData.DOB = patientSnap.val().DOB;
                                                                archiveData.gender = patientSnap.val().gender;
                                                                archiveData.currentMedication = patientSnap.val().medication;
                                                                archiveData.gmtOffset = patientSnap.val().gmtOffset;
                                                                archiveData.buildNumber = patientSnap.val().buildNumber;
                                                                archiveData.patientName = userName;
                                                                archiveData.convoCount =
                                                                    chatCount !== null && chatCount !== undefined
                                                                        ? Object.keys(chatCount).length
                                                                        : 0;
                                                                archiveData.doctorName = doctorSnap.val().fullName;
                                                                archiveData.doctorID = valSnap.val().doctorID;
                                                                archiveData.doctorProfileImg = doctorSnap.val().profileImageURL;
                                                                archiveData.doctorEmail = doctorSnap.val().staffEmail;
                                                                archives.push(archiveData);

                                                                if (count - 1 === i) {
                                                                    returnArchives(dispatch, [], archives, count, i);
                                                                } else {
                                                                    i = i + 1;
                                                                }
                                                            } else {
                                                                i = i + 1;
                                                                if (count === i && archives.length === 0) {
                                                                    dispatch({type: FETCH_ARCHIVES_STATUS_FAILED});
                                                                } else if (count === i && archives.length !== 0) {
                                                                    returnArchives(dispatch, [], archives, count, i);
                                                                }
                                                            }
                                                        });
                                                    } else {
                                                        i = i + 1;
                                                        if (count === i && archives.length === 0) {
                                                            dispatch({type: FETCH_ARCHIVES_STATUS_FAILED});
                                                        } else if (count === i && archives.length !== 0) {
                                                            returnArchives(dispatch, [], archives, count, i);
                                                        }
                                                    }
                                                }
                                            );
                                        } else {
                                            i = i + 1;
                                            if (count === i && archives.length === 0) {
                                                dispatch({type: FETCH_ARCHIVES_STATUS_FAILED});
                                            } else if (count === i && archives.length !== 0) {
                                                returnArchives(dispatch, [], archives, count, i);
                                            }
                                        }
                                    } else {
                                        i = i + 1;
                                        if (count === i && archives.length === 0) {
                                            dispatch({type: FETCH_ARCHIVES_STATUS_FAILED});
                                        } else if (count === i && archives.length !== 0) {
                                            returnArchives(dispatch, [], archives, count, i);
                                        }
                                    }
                                });
                            });
                        } else {
                            dispatch({type: FETCH_ARCHIVES_STATUS_FAILED});
                        }
                    });
                });
            } else {
                dispatch({type: FETCH_ARCHIVES_STATUS_FAILED});
            }
        });
    };
};

export const fetchClinicalArchives = (oldArchives, timestamp, clinicid) => {
    return dispatch => {
        dispatch({type: FETCH_ARCHIVES_LOADING});
        var archives = [];
        let archive_list = getClinicalArchivesRef(clinicid).orderByChild("timestamp").limitToLast(100);
        if (Boolean(timestamp)) archive_list = archive_list.endAt(timestamp);
        archive_list.once("value", archiveSnap => {
            if (archiveSnap.val()) {
                var count = archiveSnap.numChildren();
                var i = 0;
                var archive_index = 0;
                archiveSnap.forEach(valSnap => {
                    archive_index = archive_index + 1;
                    if (!valSnap.val().status && valSnap.val().doctorID === auth.currentUser.uid) {
                        getClinicStaffMemberRef(clinicid, valSnap.val().doctorID).once("value", doctorSnap => {
                            if (doctorSnap.val()) {
                                getUserRef(valSnap.val().patientID).once("value", patientSnap => {
                                    if (patientSnap.val()) {
                                        let userName =
                                            (patientSnap.val().userName === "No name" ||
                                                patientSnap.val().userName === "Patient") &&
                                            patientSnap.val().name
                                                ? patientSnap.val().name
                                                : patientSnap.val().userName;
                                        let archiveData = valSnap.val();
                                        let chatCount = patientSnap.val().history_conversations;
                                        archiveData.conversationID = valSnap.key;
                                        archiveData.patientEmail = patientSnap.val().email;
                                        archiveData.city = patientSnap.val().city;
                                        archiveData.country = patientSnap.val().country;
                                        archiveData.platform = patientSnap.val().platform;
                                        archiveData.DOB = patientSnap.val().DOB;
                                        archiveData.gender = patientSnap.val().gender;
                                        archiveData.currentMedication = patientSnap.val().medication;
                                        archiveData.gmtOffset = patientSnap.val().gmtOffset;
                                        archiveData.buildNumber = patientSnap.val().buildNumber;
                                        archiveData.patientName = userName;
                                        archiveData.convoCount =
                                            chatCount !== null && chatCount !== undefined
                                                ? Object.keys(chatCount).length
                                                : 0;
                                        archiveData.doctorName = doctorSnap.val().fullName;
                                        archiveData.doctorID = valSnap.val().doctorID;
                                        archiveData.doctorProfileImg = doctorSnap.val().profileImageURL;
                                        archiveData.doctorEmail = doctorSnap.val().staffEmail;
                                        archiveData.signatureURL = doctorSnap.val().signatureImageURL;
                                        archiveData.licenseNo = doctorSnap.val().licenseNo;
                                        archiveData.patient_profile = patientSnap.val().PatientProfile;
                                        archives.push(archiveData);

                                        if (count - 1 === i) {
                                            returnArchives(dispatch, oldArchives, archives, count, i);
                                        } else {
                                            i = i + 1;
                                        }
                                    } else {
                                        i = i + 1;
                                        if (count === i && archives.length === 0) {
                                            dispatch({type: FETCH_ARCHIVES_STATUS_FAILED});
                                        } else if (count === i && archives.length !== 0) {
                                            returnArchives(dispatch, oldArchives, archives, count, i);
                                        }
                                    }
                                });
                            } else {
                                getdoctorByRef(valSnap.val().doctorID).once("value", doctorSnap => {
                                    if (doctorSnap.val()) {
                                        getUserRef(valSnap.val().patientID).once("value", patientSnap => {
                                            if (patientSnap.val()) {
                                                let userName =
                                                    (patientSnap.val().userName === "No name" ||
                                                        patientSnap.val().userName === "Patient") &&
                                                    patientSnap.val().name
                                                        ? patientSnap.val().name
                                                        : patientSnap.val().userName;
                                                let archiveData = valSnap.val();
                                                let chatCount = patientSnap.val().history_conversations;
                                                archiveData.conversationID = valSnap.key;
                                                archiveData.patientEmail = patientSnap.val().email;
                                                archiveData.city = patientSnap.val().city;
                                                archiveData.country = patientSnap.val().country;
                                                archiveData.platform = patientSnap.val().platform;
                                                archiveData.DOB = patientSnap.val().DOB;
                                                archiveData.gender = patientSnap.val().gender;
                                                archiveData.currentMedication = patientSnap.val().medication;
                                                archiveData.gmtOffset = patientSnap.val().gmtOffset;
                                                archiveData.buildNumber = patientSnap.val().buildNumber;
                                                archiveData.patientName = userName;
                                                archiveData.convoCount =
                                                    chatCount !== null && chatCount !== undefined
                                                        ? Object.keys(chatCount).length
                                                        : 0;
                                                archiveData.doctorName = doctorSnap.val().fullName;
                                                archiveData.doctorID = valSnap.val().doctorID;
                                                archiveData.doctorProfileImg = doctorSnap.val().profileImageURL;
                                                archiveData.doctorEmail = doctorSnap.val().email;
                                                archives.push(archiveData);

                                                if (count - 1 === i) {
                                                    returnArchives(dispatch, oldArchives, archives, count, i);
                                                } else {
                                                    i = i + 1;
                                                }
                                            } else {
                                                i = i + 1;
                                                if (count === i && archives.length === 0) {
                                                    dispatch({type: FETCH_ARCHIVES_STATUS_FAILED});
                                                } else if (count === i && archives.length !== 0) {
                                                    returnArchives(dispatch, oldArchives, archives, count, i);
                                                }
                                            }
                                        });
                                    } else {
                                        i = i + 1;
                                        if (count === i && archives.length === 0) {
                                            dispatch({type: FETCH_ARCHIVES_STATUS_FAILED});
                                        } else if (count === i && archives.length !== 0) {
                                            returnArchives(dispatch, oldArchives, archives, count, i);
                                        }
                                    }
                                });
                            }
                        });
                    } else {
                        i = i + 1;
                        if (count === i && archives.length === 0) {
                            dispatch({type: FETCH_ARCHIVES_STATUS_FAILED});
                        } else if (count === i && archives.length !== 0) {
                            returnArchives(dispatch, oldArchives, archives, count, i);
                        }
                    }
                });
            } else {
                dispatch({type: FETCH_ARCHIVES_STATUS_FAILED});
            }
        });
    };
};

const returnArchives = (dispatch, oldArchives, archives, count, i) => {
    var sorted_archives =
        archives.length > 1 ? _.orderBy(archives, ["timestamp"], ["desc"]) : archives;
    var time = sorted_archives[sorted_archives.length - 1].timestamp;
    var index = oldArchives.length;
    sorted_archives =
        sorted_archives.length === 100
            ? sorted_archives.slice(0, sorted_archives.length - 1)
            : sorted_archives;
    var new_Array = _.concat(oldArchives, sorted_archives);

    dispatch({
        type: FETCH_ARCHIVES_STATUS,
        payload: {
            sorted_archives: new_Array,
            time: time,
            previous_length: index,
            isLast: count !== 100,
        },
    });
};

const getClinicalArchivesRef = clinicName => {
    return database.ref(`/clinicArchiveConversations/${clinicName}`);
};
const getClinicalArchiveRef = (clinicName, convoId) => {
    return database.ref(`/clinicArchiveConversations/${clinicName}/${convoId}`);
};

const getArchivesRef = () => {
    return database.ref().child("archiveConversations");
};

const getdoctorByRef = uid => {
    return database.ref(`/doctors/${uid}`);
};

const getClinicStaffMemberRef = (ID, uid) => {
    return database.ref(`/clinicStaffMember/${ID}/${uid}`);
};

const getUserRef = uid => {
    return database.ref(`/users/${uid}`);
};

const getConversationRef = location => {
    return database.ref(`/conversations/${location}`);
};

const getOpenArchivesRef = () => {
    return database.ref(`/openconversations/`);
};

const getUserHistoryConversationRef = userId => {
    return database.ref(`/users/${userId}/history_conversations`);
};
